import { Component, OnInit, ViewEncapsulation,  } from '@angular/core';
import { NavigationStart, NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { MenuController, Platform, PopoverController, ToastController } from '@ionic/angular';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { Storage } from '@ionic/storage';

import { UserProvider } from './providers/user-provider';

import{ Globals } from '../app/providers/globals'
import{ ContentSetGlobal } from '../app/providers/contentset-global'
import { UserBrandProvider } from '../app/providers/user-brand-provider'
import { BrandProvider } from '../app/providers/brand-provider'
import { SettingsPopoverComponent } from './components/settings-popover/settings-popover.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {

  loggedIn = false;
  dark = true;
  brandInfo: any = null;

  constructor(
    private menu: MenuController,
    private platform: Platform,
    private router: Router,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private storage: Storage,
    private userData: UserProvider,
    private swUpdate: SwUpdate,
    private toastCtrl: ToastController,
    public globals: Globals,
    public contentSetGlobal: ContentSetGlobal,
    private popoverController : PopoverController,
    private userBrandsData: UserBrandProvider,
    private brandsData: BrandProvider
  ) {
    this.initializeApp();
  }

  async ngOnInit() {
    //set menu visibility
    // this.menu.enable(false); 
    this.menu.enable(this.globals.menuOpen);

    this.swUpdate.available.subscribe(async res => {
      const toast = await this.toastCtrl.create({
        message: 'Update available!',
        position: 'bottom',
        buttons: [
          {
            role: 'cancel',
            text: 'Reload'
          }
        ]
      });

      await toast.present();

      toast
        .onDidDismiss()
        .then(() => this.swUpdate.activateUpdate())
        .then(() => window.location.reload());
    });
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      //set mobile device global
      if(this.platform.platforms().filter(p => (p == "android" || p =="ios")).length > 0)
        this.globals.isMobileApp = true;

      if(this.platform.is("android"))
        this.globals.isAndroid = true;

      if(this.mobileCheck()){ //this.platform.is("mobileweb") && 
        this.globals.isMobileBrowser = true;

      }
 
      //load all globals 
      var loggedIn = await this.globals.login();
      if(loggedIn){
        //load content related data
        await this.contentSetGlobal.load();
      }

    });
  }

  mobileCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    
    if(!check)
      if(window.innerWidth <= 600)
        check = true;
    
    return check;
  };


  logout() {
    this.userData.logout().then(() => {
      return this.router.navigateByUrl('/sign-in');
    });
  }

  firstToggle: boolean = true;

  toggleMenu(){
    this.globals.menuOpen = !this.globals.menuOpen;

      document.querySelectorAll(
        `.side-menu, 
        .main-menu-content, 
        .main-menu-list, 
        .main-menu-item, 
        .main-menu-item-header, 
        .menu-icon, 
        .main-menu-toggle,
        .main-menu-item-label`)
        .forEach(el => {

          el.classList.add("menu-transition");

            if(!this.globals.menuOpen)
              el.classList.add("closed");
            else
              el.classList.remove("closed");
        })

        var logo = document.querySelector(".top-logo-container > .item-native > .item-inner");
        if(logo){
          if(!this.globals.menuOpen)
            logo.classList.add("logo-inner-closed");
          else
            logo.classList.remove("logo-inner-closed");
        }

      this.firstToggle = false;

  }

  async openSettings(){

    var settings = [];
    
    if(!this.globals.loggedIn){
      settings.push({
        id: "",
        name: "Log in",
        icon: "log-in",
        click: () => {
          this.globals.navigateToSignIn();
        }
      },
      {
      id: "",
      name: "Sign up",
      icon: "log-in",
      click: () => {
        this.globals.navigateToSignIn();
      }
    })
    }
    else{
      settings.push(  {
        id: "",
        name: "Account",
        icon: "person"
      });

      if(!this.globals.isDesigner){
        settings.push({
          id: "",
          name: "I'm a Designer",
          icon: "color-palette-outline",
          click: () => {
            this.globals.saveIsDesigner(true)
            this.globals.navigateToDesignerHome(false, true);
            
          }
        })
      }
      else{
        settings.push({
          id: "",
          name: "Let's Create Content",
          icon: "film-outline",
          click: () => {
            this.globals.saveIsDesigner(false);
            this.globals.navigateToCreatorHome(false, true);
          }
        })
      }
      settings.push({
        id: "",
        name: "Contact Us",
        icon: "help",
        href: "mailto:river@contentjaguar.com"
      });

      if(this.globals.isMultiBrand){
        settings.push({
          id: "",
          name: "Switch Brands",
          icon: "refresh",
          click: async () => {
            await this.loadBrandData(true);
            window.location.reload();
          }
        });
      }

      settings.push({
        id: "",
        name: "Log out",
        icon: "log-out",
        click: () => {
          this.globals.logout();
        }
      });
    }

  const popover = await this.popoverController.create({
    component: SettingsPopoverComponent,
    componentProps: {
      'itemlist': settings,
      'header' : "",
      'isMoreInformation': false,
      "showClearFilter": false,
      "customEvents" : true
    },
    cssClass: 'settings-popover',
    // event: event,
    translucent: false,
    showBackdrop: true,
    animated: true,
    backdropDismiss: true
  });

  await popover.present();

  const {data} = await popover.onDidDismiss();
}


  loadBrandData(refresh){
    return new Promise(async (resolve, reject) =>{
      this.userBrandsData.getUserInfo(refresh).subscribe(async (userInfo: any) => {
        if(userInfo.brands){
          if(userInfo.brands.length == 0){
            this.globals.showIssue("Your account isn't associated with any brands. Please contact the Contact Jaguar team.");
            return;
          }

          if(userInfo.roles)
            if(userInfo.roles.length > 0)
              if(userInfo.roles.includes("Administrator"))
                this.globals.saveIsAdministrator(true);

          if(userInfo.hasPurchased)
              this.globals.saveHasPurchased(true);


          //If more than one brand comes back
          //This user is mapped to multi brands
          //allow them to select a brand
          var brandId;
          if(userInfo.brands.length > 1)
            brandId = await this.handleMultiBrands(userInfo.brands);
          else
            brandId = userInfo.brands[0].brandId;

          //save brand id for use in app globally
          this.globals.saveBrandId(brandId);

          this.brandsData.getBrandInfo(refresh).subscribe((brandInfo: any) => {
            if(brandInfo){
              this.globals.savePurchaseMode(brandInfo.isPurchaseMode);
              this.globals.saveBrandData(brandInfo);

              resolve(brandInfo);
            }
          });
        }
      });
    });
}

async handleMultiBrands(brandList){
  return new Promise(async (resolve, reject) =>{

    this.globals.saveIsMultiBrand(true);

    brandList.forEach(b => {
      b.name = b.brandName;
      b.id = b.brandId;
    });

    const popover = await this.popoverController.create({
      component: SettingsPopoverComponent,
      componentProps: {
        'itemlist': brandList,
        'header' : "Choose A Brand",
        'isMoreInformation': false,
        "showClearFilter": false,
        "customEvents" : false
      },
      cssClass: 'settings-popover',
      // event: event,
      translucent: false,
      showBackdrop: true,
      animated: true,
      backdropDismiss: false
    });

    await popover.present();

    const {data} = await popover.onDidDismiss();

    resolve(data.itemSelected.id);
  });
}

  openAbout() {
    this.globals.menuOpen = false;
    this.menu.enable(this.globals.menuOpen);
    this.storage.set('ion_did_tutorial', false);
    this.router.navigate(['']);
  }

  openMoreInfo() {
    this.globals.menuOpen = false;
    this.menu.enable(this.globals.menuOpen);
    this.storage.set('ion_did_tutorial', false);
    this.router.navigate(['learn-more']);
  }

  closeDownload(event){
    this.globals.saveDownloadUrl("");
  }

  downloadReadyClicked(event){
    this.globals.saveDownloadUrl("");
  }

}
